// Write some helpers
import { useDataChange } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'question',
  })

  return function onChange(value) {
    change(next => {
      next.type = value

      if (!['choice', 'multiplechoice'].includes(value)) {
        next.options = null
      }
    })
  }
}
